export const USER_SESSION = "USER_SESSION";
export const USER_SESSION_SUCCESS = "USER_SESSION_SUCCESS";
export const USER_SESSION_FAILURE = "USER_SESSION_FAILURE";
export const USER_SESSION_INIT = "USER_SESSION_INIT";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";
export const LOGIN_USER_INIT = "LOGIN_USER_INIT";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAILURE = "LOGOUT_USER_FAILURE";
export const LOGOUT_USER_INIT = "LOGOUT_USER_INIT";

export const VERIFY_PASSWORD = "VERIFY_PASSWORD";
export const VERIFY_PASSWORD_SUCCESS = "VERIFY_PASSWORD_SUCCESS";
export const VERIFY_PASSWORD_FAILURE = "VERIFY_PASSWORD_FAILURE";
export const VERIFY_PASSWORD_INIT = "VERIFY_PASSWORD_INIT";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const CHANGE_PASSWORD_INIT = "CHANGE_PASSWORD_INIT";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const FORGOT_PASSWORD_INIT = "FORGOT_PASSWORD_INIT";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";
export const RESET_PASSWORD_INIT = "RESET_PASSWORD_INIT";

export const SELECT_COMPETITION = "SELECT_COMPETITION";
export const SELECT_SCHOOL = "SELECT_SCHOOL";
export const SELECT_CLASS = "SELECT_CLASS";
export const SELECT_STUDENT = "SELECT_STUDENT";

export const SET_IS_VIEWING_STATUS = "SET_IS_VIEWING_STATUS";

export const SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED = "SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED"
export const SCHOOL_SUBTOPIC_OVERALL_REPORT_SUCCESS = "SCHOOL_SUBTOPIC_OVERALL_REPORT_SUCCESS"
export const SCHOOL_SUBTOPIC_OVERALL_REPORT_FAILURE = "SCHOOL_SUBTOPIC_OVERALL_REPORT_FAILURE"

export const CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED = "CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED"
export const CLASS_SUBTOPIC_OVERALL_REPORT_SUCCESS = "CLASS_SUBTOPIC_OVERALL_REPORT_SUCCESS"
export const CLASS_SUBTOPIC_OVERALL_REPORT_FAILURE = "CLASS_SUBTOPIC_OVERALL_REPORT_FAILURE"

export const SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED = "SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED"
export const SCHOOL_SUBTOPIC_SKILL_REPORT_SUCCESS = "SCHOOL_SUBTOPIC_SKILL_REPORT_SUCCESS"
export const SCHOOL_SUBTOPIC_SKILL_REPORT_FAILURE = "SCHOOL_SUBTOPIC_SKILL_REPORT_FAILURE"

export const CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED = "CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED"
export const CLASS_SUBTOPIC_SKILL_REPORT_SUCCESS = "CLASS_SUBTOPIC_SKILL_REPORT_SUCCESS"
export const CLASS_SUBTOPIC_SKILL_REPORT_FAILURE = "CLASS_SUBTOPIC_SKILL_REPORT_FAILURE"

export const SUBTOPIC_REPORT_RESET = "SUBTOPIC_REPORT_RESET"

export const FETCH_CT_QUESTION = "FETCH_CT_QUESTION"
export const FETCH_CT_QUESTION_SUCCESS = "FETCH_CT_QUESTION_SUCCESS"
export const FETCH_CT_QUESTION_FAILURE = "FETCH_CT_QUESTION_FAILURE"
export const FETCH_CT_QUESTION_RESET = "FETCH_CT_QUESTION_RESET"
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"

export const COMPETITION_RESET_REQUESTED = "COMPETITION_RESET_REQUESTED";
export const COMPETITION_RESET_SUCCESS = "COMPETITION_RESET_SUCCESS";
export const COMPETITION_RESET_FAILURE = "COMPETITION_RESET_FAILURE";
export const RESET_COMPETITION_RESCHEDULE = "RESET_COMPETITION_RESCHEDULE";

export const DOWNLOAD_REPORT_REQUESTED = "DOWNLOAD_REPORT_REQUESTED";
export const DOWNLOAD_REPORT_SUCCESS = "DOWNLOAD_REPORT_SUCCESS";
export const DOWNLOAD_REPORT_FAILURE = "DOWNLOAD_REPORT_FAILURE";